var sc = sc || {};
sc.alpine = sc.alpine || {};

sc.alpine.downloadButton = function () {
    return {
        id: 'downloadButton',
        token: 'token',
        button: {
            ['x-on:click']() {
                this.$el.style.pointerEvents = 'none'; //disable link

                this.width = this.$el.style.width;
                this.height = this.$el.style.height;
                this.html = this.$el.innerHTML;

                this.$el.style.width = this.$el.offsetWidth + 'px';
                this.$el.style.height = this.$el.offsetHeight + 'px';
                this.$el.innerHTML = '<div class="flex justify-center w-full"><svg class="animate-spin h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">' +
                    '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>' +
                    '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>' +
                    '</svg></div>';

                this.autoIntervalTest = true;
            },
        },
        init() {
            this.$interval(this.functionToRun, this.timer);
        },
        width: '',
        height: '',
        html: '',
        timer: 1000,
        autoIntervalTest: false,
        functionToRun: function () {
            console.log('Waiting for download...');

            var cookieToken = this.getCookie("downloadToken");
            if (this.token == cookieToken) {
                console.log('Cookie Found...');
                this.$el.style.pointerEvents = 'auto'; //enable link
                this.expireCookie("downloadToken");

                this.$el.style.width = this.width;
                this.$el.style.height = this.height;
                this.$el.innerHTML = this.html;

                setTimeout(() => { this.autoIntervalTest = false }, 100);
            }

        },
        getCookie(name) {
            var parts = document.cookie.split(name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
        },
        expireCookie(cName) {
            document.cookie = encodeURIComponent(cName) + '=; Max-Age=0; path=/; domain=' + location.host.split(':')[0];
        }
    }
}